import React, { createContext, useCallback, useContext, useState } from 'react';
import { Assets } from '../types/kpis';

interface DisabledTypes {
  roads: boolean;
  trucks: boolean;
  drills: boolean;
}

interface PreferencesState {
  dataType: Assets;
}

interface PreferencesContextData {
  dataType: Assets;
  disabledTypes: DisabledTypes;
  selectDataType(type: string): void;
  disableTabs(tabs: DisabledTypes): void;
}

const PreferencesContext = createContext<PreferencesContextData>(
  {} as PreferencesContextData,
);

const PreferencesProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<PreferencesState>({} as PreferencesState);
  const [disabledTypes, setDisabledTypes] = useState<DisabledTypes>({
    roads: false,
    trucks: false,
    drills: false,
  });

  const selectDataType = useCallback((type: Assets): void => {
    setData({ dataType: type });
  }, []);

  const disableTabs = useCallback((tabs: DisabledTypes): void => {
    setDisabledTypes(tabs);
  }, []);

  return (
    <PreferencesContext.Provider
      value={{
        dataType: data.dataType,
        disabledTypes,
        selectDataType,
        disableTabs,
      }}
    >
      {children}
    </PreferencesContext.Provider>
  );
};

function usePreferences(): PreferencesContextData {
  const context = useContext(PreferencesContext);

  if (!context) {
    throw new Error('usePreferences must be used within a PreferencesProvider');
  }

  return context;
}

export { PreferencesProvider, usePreferences };
